import React from 'react';
import { ToastData } from '@/types/toast';
import Toast from './Toast';

interface ToastContainerProps {
  toasts: ToastData[];
  onDismiss: (id: string) => void;
}

export default function ToastContainer({ toasts, onDismiss }: ToastContainerProps) {
  return (
    <>
      {/* Desktop: Top-right stack */}
      <div className="hidden md:block fixed top-20 right-4 z-50 space-y-2">
        {toasts.map((toast, index) => {
          const { id, ...toastProps } = toast;
          return (
            <Toast
              key={id}
              {...toastProps}
              onDismiss={() => onDismiss(id)}
              style={{ animationDelay: `${index * 100}ms` }}
            />
          );
        })}
      </div>

      {/* Mobile: Bottom, one at a time */}
      <div className="md:hidden fixed bottom-4 left-4 right-4 z-50">
        {toasts.slice(0, 1).map(toast => {
          const { id, ...toastProps } = toast;
          return <Toast key={id} {...toastProps} onDismiss={() => onDismiss(id)} mobile />;
        })}
      </div>
    </>
  );
}
